<template>
  <v-card :loading="isLoading">
    <div class="card card-custom gutter-b example example-compact">
      <v-card-title>
        <h3 class="card-label">
          <div v-if="originalData.name">
            <small>Gider Tipi</small><br />
            <span>{{ originalData.name }}</span>
          </div>
          <span v-else>Gider Tipi</span>
          <div>
            <small>{{ cluster.name }} Gider Tipi</small>
          </div>
        </h3>
        <v-col class="text-right p-0">
          <v-btn
            class="me-2"
            color="pink"
            outlined
            @click="showActionLogs"
            v-if="id"
            icon
            small
          >
            İ
          </v-btn>
        </v-col>
        <div class="d-block w-100 mb-2">
          <rs-return-to />
        </div>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="handleFormSubmit">
          <v-row dense>
            <v-col sm="12">
              <rs-text-field
                label="Adı"
                :rules="[rules.required, rules.maxLength(formData.name, 100)]"
                v-model="formData.name"
                :readonly="disabled || (id && !originalData.cluster_id)"
                :filled="disabled || (id && !originalData.cluster_id)"
              />
            </v-col>

            <v-col sm="12">
              <rs-select-expense-type
                label="Gider Türü"
                :rules="[rules.required]"
                v-model="formData.parent_id"
                :readonly="disabled"
                :filled="disabled"
                required
                :disabled="ifParentId"
              />
            </v-col>

            <!-- <v-col sm="12">
              <rs-bank-keywords
                v-model="formData.bank_keywords"
                :readonly="disabled"
                :filled="disabled"
              />
            </v-col> -->
            <v-col cols="12">
              <v-switch
                v-model="formData.is_active"
                :label="formData.is_active ? $t('active') : $t('passive')"
                hide-details="auto"
                :readonly="disabled"
                :filled="disabled"
              />
            </v-col>
          </v-row>

          <rs-form-buttons
            :isLoading="isLoading"
            @cancel="handleCancelClick"
            v-if="!disabled"
            @submit.prevent="handleFormSubmit"
          />
        </v-form>
        <ActionLogList ref="actionLogList" />
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ActionLogList from "@/view/content/action-logs/ActionLogList";
import hasForm from "@/view/mixins/hasForm";

export default {
  mixins: [hasForm],
  props: {
    id: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ActionLogList,
  },
  watch: {
    id() {
      this.load();
    },
    clusterId: {
      handler() {
        if (this.id) {
          return;
        }

        this.$nextTick(() => {
          if (this.clusterId) {
            this.formData.cluster_id = this.clusterId;
          } else {
            this.formData.cluster_id = null;
          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["clusterId", "cluster", "expenseTypeList"]),
  },
  mounted() {
    if (this.$router.currentRoute.query.parent_id) {
      this.formData.parent_id = parseInt(
        this.$router.currentRoute.query.parent_id
      );
      this.ifParentId = true;
    }
    this.$nextTick(() => {
      if (this.id) {
        this.load();
      }
    });
  },
  data() {
    return {
      formData: {
        cluster_id: null,
        name: null,
        // bank_keywords: [],
        parent_id: null,
        is_active: true,
      },
      originalData: {},
      ifParentId: false,
    };
  },
  methods: {
    ...mapActions(["updateClusterId"]),
    /**
     * Retrieves item data
     * @return {Promise} Resolves if data is retrieved
     */
    load() {
      this.isLoading = true;

      return this.$api
        .query(`types/expense-types/${this.id}`)
        .then((response) => {
          this.originalData = Object.assign({}, response.data.data);

          for (const index in this.formData) {
            if (response.data.data[index] !== undefined) {
              this.formData[index] = response.data.data[index];
            }
          }

          if (
            this.originalData.cluster_id &&
            this.clusterId !== this.originalData.cluster_id
          ) {
            this.updateClusterId(this.originalData.cluster_id);
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleFormSubmit(event) {
      if (this.isLoading || !this.$refs.form.validate()) {
        this.$toast.error("Lütfen tüm gerekli alanları doldurunuz");
        return false;
      }

      this.isLoading = true;
      const formData = Object.assign(
        { cluster_id: this.cluster_id },
        this.formData
      );
      formData.name = this.formData.name;
      formData.cluster_id = this.formData.cluster_id;
      // formData.bank_keywords = this.formData.bank_keywords;
      formData.parent_id = this.formData.parent_id;

      if (this.id) {
        this.$api
          .put(`types/expense-types/${this.id}`, formData)
          .then((response) => {
            this.$toast.success("Kaydedildi");
            if (event && event.closeOnSave) {
              this.$router.back();
              return;
            }

            this.loadData(response);

            this.name = response.data.data.name;
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$api
          .post(`types/expense-types`, formData)
          .then((response) => {
            this.$toast.success("Kaydedildi");
            if (event && event.closeOnSave) {
              this.$router.back();
              return;
            }

            this.$router.replace({
              name: "other-definitions.child-expense-types.edit",
              params: { id: response.data.data.id },
            });
          })
          .catch((error) => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    handleCancelClick() {
      this.$router.back();
    },
    showActionLogs() {
      this.$refs.actionLogList.show("App\\Models\\Type\\ExpenseType", this.id);
    },
  },
};
</script>
